import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_IMPORTER_SCHEMAS](state, payload) {
    state.importerSchemas = payload;
  },
};
